<template>
  <div :class="{ 'landscape-mode': isLandscape }">
    <div class="meeting-live1">
      <!-- <top :title="liveDetails.button_name || '大会直播'" :color="theme_color"></top> -->
      <div v-if="hasAuth == true" class="all">
        <van-sticky :offset-top="0" @change="checkElementAtTop">
          <div class="timeTabs-wrap" v-if="hasScheduleDate" id="top">
            <div class="nav-icon" :style="{ color: theme_color || '#901d22' }">
              <van-icon name="arrow-left" size="24" @click="onClickLeft" />
            </div>

            <div class="timeTabs-wrap-inner">
              <div class="timeTabs" v-if="theme_color">
                <div class="tab-item" :style="{
                  background: theme_color,
                  border: 'none'
                }">
                  {{ scheduleDate1[0] }}
                </div>
              </div>
              <div class="timeTabs" v-else>
                <div class="tab-item active">
                  {{ scheduleDate1[0] }}
                </div>
              </div>
              <h3>
                {{
                  liveDetails.daily_preview_title
                    ? liveDetails.daily_preview_title
                    : liveDetails.name
                }}
                <!-- <span v-if="liveDetails.hall_name">（{{ liveDetails.hall_name }}）</span> -->
              </h3>
            </div>
            <div class="nav-icon" :style="{ color: theme_color || '#901d22' }" @click="goHome" >
              <van-icon name="wap-home-o"  size="24" />
              <span style="font-size: 15px;">返回首页</span>
            </div>
          </div>
          <div class="video" id="video">
            <div class="viewNumber" v-if="liveDetails.show_views && liveDetails.only_show_banner == 0">
              观看人数 : {{ viewNum }}人
            </div>
            <p class="viewNumber" v-if="liveDetails.meeting && liveDetails.meeting.show_views"> 观看人数 : {{ viewNum }}人
            </p>
            <player ref="player" :videoUrl="videoUrl" :zimuInfo="zimuList" :show_zimu_player="show_zimu_player"
              :show_zimu_tab="show_zimu_tab" @updateZimu="updateZimu" :session_id="this.id" v-if="JSON.stringify(liveDetails) != '{}' &&
                liveDetails.only_show_banner == 0
              "></player>
            <img :src="liveDetails.banner" style="width:100%" v-if="liveDetails.banner_type == 1 && liveDetails.only_show_banner == 1
            " />

            <div class="bgCover2" v-if="liveDetails.banner_type == 2 && liveDetails.only_show_banner == 1
            ">
              <img :src="liveDetails.banner" alt="" />
              <ul>

                <li :style="{ 'color': liveDetails.schedule_font_color_hex }" v-for="(ct, c) in bannerChapterList"
                  :key="c">
                  <span
                    :style="{ 'background-color': liveDetails.schedule_font_color_hex ? liveDetails.schedule_font_color_hex : '#fff' }"></span>
                  {{ ct.name }}
                </li>
              </ul>
            </div>
            <div class="lines-buttons" v-if="more_lines"
              style="text-align:center;padding:10px;background-color: #fff;width: 100%;">
              <van-button v-for="(item, index) in line_buttons" :key="index" size="small" :style="{
                'margin-right': index < line_buttons.length - 1 ? '10px' : ''
              }" :color="line_index == index ? '#d2020d' : ''" @click="changeLine(item, index)">{{ item.rtc_name
              }}</van-button>
            </div>

            <div class="swiper-img" v-if="swiperImg.length">
              <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
                  <img :src="item.banner_url" alt="" />
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
          <!-- <div class="hr-7" ref="line"></div> -->
        </van-sticky>

        <div class="container">
          <van-tabs v-model="active" animated swipeable :sticky="isTabsFixed && !isLandscape" :offset-top="tabsOffTop"
            z-index="999" lazy-render color="#901d22" title-inactive-color="#999" title-active-color="#090909"
            @change="changeTab" :ellipsis="false">
            <van-tab title="日程安排" v-if="show_detail == true">
              <schedule ref="schedule" :meetingSchedule="meetingSchedule" :color="theme_color" :endTime="meetingEndTime"
                @getLiveInfo="getLiveInfo" @initPageScroll="initPageScroll" @showChargePopup="showChargePopup"
                :isWxBtn="isWxBtn" :meetingInfo="liveDetails.meeting || {}" @subscribeTime="subscribeTime"
                @showWantLook="showWantLook" @refreshVideoZimu="refreshVideoZimu"
                @showChargeAISummary="showChargeAISummary"></schedule>
            </van-tab>
            <van-tab title="会议介绍" v-else>
              <introduction :meetingDes="meetingDes"></introduction>
            </van-tab>
            <van-tab :title="meeting_id == 616 || meeting_id == 618 ? '往期回顾' : '切换会场'"
              v-if="is_show_meetingPlace == true">
              <meeting-place :meetingDays="meetingDays" :color="theme_color" :rememberDate="false"></meeting-place>
            </van-tab>
            <van-tab title="字幕" v-if="show_zimu_tab && liveStatus == 1">
              <zimu :zimuList="zimuList" @refreshVideoZimu="refreshVideoZimu" :lang="zimuLang"></zimu>
            </van-tab>
            <van-tab title="互动讨论">
              <discuss v-if="websock" ref="discuss" :admin="admin" :websock="websock" :topicList="topicList"
                :color="theme_color">
              </discuss>
            </van-tab>
            <van-tab :title="meeting_id == 709 ? '新技术介绍' : meeting_id == 787 ? '云展台' : '会议介绍'"
              v-if="is_show_des && show_detail == true && meeting_id != 616 && meeting_id != 618">
              <introduction :meetingDes="meetingDes"></introduction>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <van-popup v-model="showActivity" position="center" @close="closePop" :close-on-click-overlay="closeOverlay">
        <collect-info :fieldArr="fieldArr" :formset="formset" @func="changeInfoStatus" :mobile="userInfo.mobile"
          @changeAuth="changeAuth($event)" :meetingId="meeting_id"></collect-info>
      </van-popup>
      <!-- 手机号 -->
      <van-popup v-model="is_show_phone_popup" position="center" class="phone_popup"
        :style="{ width: '80%', 'min-height': '210px' }">
        <h4>请输入您的手机号</h4>
        <van-field v-model="updateMobile" type="tel" label="手机号" :label-width="80" />
        <div class="submit" @click="submitPhone">提交</div>
      </van-popup>
      <!-- 弹出二维码 -->
      <van-popup v-model="is_show_recommend_qrcode" closeable position="center" class="qrcode"
        :style="{ width: '280px', height: '280px' }">
        <img :src="liveDetails.recommend_qrcode_url" alt="" />
      </van-popup>
      <!-- 弹出二维码 -->
      <van-popup v-model="is_show_extend" closeable position="bottom" class="extend"
        :style="{ width: '100%', height: '280px' }">
        <div class="half">
          <span class="attention">关注</span>
          <img :src="extend_pop.live_ad_img" alt="" />
        </div>
        <div class="half">
          <p v-html="extend_pop.live_ad_content" class="extend-content"></p>
        </div>
      </van-popup>
      <!-- 注册付费 -->
      <img v-if="is_show_charge" class="icon_charge_top" src="@/assets/images/Meeting/Meeting_playback.png" alt="">
      <van-popup v-model="is_show_charge" position="center" class="charge"
        :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px' }" :close-on-click-overlay="false">
        <div class="filter"></div>
        <h4>注册付费，观看录播回放</h4>
        <p>注册付费后<br>
          即可观看录播回放</p>
        <div class="handles">
          <div class="no" @click="is_show_charge = false">不用了</div>
          <div class="red" @click="goRegisterCharge">去注册</div>
        </div>
      </van-popup>
      <van-popup v-model="is_show_meeting_password" position="center" class="pwd_popup" 
        :lazy-render="false" :z-index="3000"
        :style="{ 'max-width': '360px', 'width': '80%', 'padding': '30px 20px 0', 'border-radius': '20px' }"
        :close-on-click-overlay="false" >
        <div >
          <h4>请输入会议密码</h4>
          <van-field v-model="passwordInputValue" type="text" label="密码" :label-width="60" />
          <div class="submit" @click="confirmMeetingPwd">确定</div>
        </div>
      </van-popup>
      <!-- 订阅时间 -->
      <van-popup v-model="showChooseTime" round class="popup-box">
        <div style="margin-top:20px;">
          <h2>请选择在本场会议正式开始前</h2>
          <van-field readonly clickable name="picker" :value="pre_time" placeholder="点击选择时间" right-icon="arrow-down"
            @click="showPicker = true"
            style="width:100px;display: inline-block;vertical-align: bottom;border: 1px solid #DCDFE6;border-radius:5px;" />
          <span style="font-size:20px;line-height:46px;">分钟</span>
          <h2 style="margin-top:10px;">通过服务号消息提醒您观看直播</h2>
          <button @click.stop="submitSubscribe">确定</button>
        </div>

      </van-popup>
      <van-popup v-model="showPicker" position="bottom" :style="{ height: '300px' }">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" title="请选择时间" />
      </van-popup>
      <!-- 登录注册medwiki -->
      <img v-if="show_bind_wiki" class="icon_charge_top sp" src="@/assets/images/Meeting/Meeting_playback.png" alt="">
      <van-popup v-model="show_bind_wiki" position="center" class="charge"
        :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px', 'max-width': '500px' }"
        :close-on-click-overlay="false">
        <div class="filter"></div>
        <h4 style="margin-bottom: 10px;">认证即可免费观看</h4>
        <p style="text-align: left;">原价1000元的参会门票，通过Wiki注册认证，即可免费观会!<br>
          限时免费时间：2025年4月23日-5月23日 </p>
        <div class="handles">
          <div class="no" @click="goBack">不用了</div>
          <div class="red" @click="goWikiLogin">去认证</div>
        </div>
      </van-popup>
      <!-- 收集认证信息用户真实姓名 -->
      <van-popup v-model="show_collect_username" position="center" class="charge" :close-on-click-overlay="false"
        :style="{ width: '80%', 'min-height': '210px', 'max-width': '500px' }">
        <h3>认证信息</h3>
        <van-field v-model="userAuthInfo.username" type="tel" :border="false" placeholder="真实姓名" required />
        <div class="handles">
          <div class="no" @click="goBack">取消</div>
          <div :style="{ background: theme_color }" class="red" @click="submitAuthInfo">确定</div>
        </div>
      </van-popup>
      <!-- 收集用户认证信息 -->
      <van-popup v-model="show_collect_authInfo" position="center" class="charge" :close-on-click-overlay="false"
        :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px', 'max-width': '500px' }">
        <h3>认证信息</h3>
        <van-field v-model="userAuthInfo.username" :border="false" placeholder="真实姓名" required />
        <van-field v-model="userAuthInfo.age" :border="false" placeholder="年龄段" readonly required is-link
          @click="showPickerAge = true" />
        <van-field v-model="userAuthInfo.hospital" :border="false" placeholder="医院/企业" required />
        <van-field v-model="userAuthInfo.depart_name" :border="false" placeholder="科室" readonly required is-link
          @click="showPickerDepart = true" />
        <van-field v-model="userAuthInfo.job_name" :border="false" placeholder="职称" readonly required is-link
          @click="showPickerJob = true" />
        <div class="handles">
          <div class="no" @click="goBack">取消</div>
          <div :style="{ background: theme_color }" class="red" @click="submitAuthInfo">确定</div>
        </div>
      </van-popup>
      <van-popup v-model="showPickerAge" position="bottom" :style="{ height: '300px' }">
        <van-picker :columns="ages" v-model="userAuthInfo.age" value-key="name" @confirm="onSelectAge" show-toolbar
          @cancel="showPickerAge = false" title="请选择年龄段" />
      </van-popup>
      <van-popup v-model="showPickerJob" position="bottom" :style="{ height: '300px' }">
        <van-picker :columns="jobs" value-key="name" @confirm="onSelectJob" show-toolbar @cancel="showPickerJob = false"
          title="请选择职称" />
      </van-popup>
      <van-popup v-model="showPickerDepart" position="bottom" :style="{ height: '300px' }">
        <van-picker :columns="departs" value-key="name" @confirm="onSelectDepart" show-toolbar
          @cancel="showPickerDepart = false" title="请选择科室" />
      </van-popup>
      <div class="want_look_tip" v-if="showWantLookTip">
        您想看的内容后续会在Med Wiki发布 <br>敬请关注
      </div>
      <!-- AI日程摘要 -->
      <van-popup v-model="showAISummary" position="bottom" :style="{ 'border-radius': '10px 10px 0 0' }">
        <div class="summary-popup">
          <h4 class="title">AI日程摘要</h4>
          <div class="info">
            <p class="name">{{ chapterAISummaryInfo.name || '' }}</p>
          </div>
          <div class="content">{{ chapterAISummaryInfo.summarization || '' }}</div>
          <!-- <p class="label" v-if="chapterAISummaryInfo.keywords && chapterAISummaryInfo.keywords.length">关键词：</p> -->
          <!-- <div class="keywords"><p v-for="(item, index) in chapterAISummaryInfo.keywords" :key="index">{{ item }}</p></div> -->
          <div class="tip">
            <img
              src="https://cdn.edstatic.com/203012120000/dc02767a1318002d1b7a9455860ff462/2026/01/2dc96823-908e-4823-9707-bb738e962111.png"
              alt="">
          </div>
        </div>

      </van-popup>
    </div>
  </div>

</template>
<script>
import { lazyRetry } from "@/assets/js/chunkLoad.js";
const Schedule = lazyRetry(() => import("../components/Meeting/Schedule"));
const Discuss = lazyRetry(() => import("../components/Meeting/Discuss"));
const MeetingPlace = lazyRetry(() => import("../components/Meeting/MeetingPlace"));
const Zimu = lazyRetry(() => import("../components/Meeting/Zimu"));

const CollectInfo = lazyRetry(() => import("@/components/Meeting/CollectInfo"));
const Player = lazyRetry(() => import("@/components/Meeting/Player"));
const Introduction = lazyRetry(() => import("@/components/Meeting/Introduction"));
const Top = lazyRetry(() => import("../components/Top"));
import { Sticky, Field, Toast, Dialog } from "vant";
import { WxShare, UpdateUserInfo, MeetingsAuthList, CollectUserAuth, RegisterWiki, VideoSubtitle, LiveVideoSubtitle } from '../../../config/interface.js';
import {
  MeetingBanner,
  MeetingsCollectInfo,
  SessionsViewsNum,
  PersoanalUserInfo,
  Signature,
  extendPop,
  NewMeetingDetail,
  NewMeetingDays,
  NewSessionDetail,
  NewSessionChapter,
  NewMeetingVerifyPwd
} from "../../../config/interface.js";
export default {
  components: {
    Schedule,
    Discuss,
    MeetingPlace,
    Player,
    Introduction,
    Top,
    CollectInfo,
    Sticky,
    Field,
    Zimu
  },
  data() {
    return {
      isLandscape: false,
      closeOverlay: false,
      time: 10 * 60 * 1000,
      admin: [], //超级管理员
      floatWindow: true, //浮窗
      showActivity: false, //活动展示
      viewGift: true, //观看直播得礼物
      active: 0,
      viewNum: 0, //观看人数
      liveDetails: {},
      meetingsPlace: [],
      signatureInfo: {},
      userInfo: "",
      meetingSchedule: {}, //会议日程 { 日期: { 会场: chapters } }
      videoUrl: "", //视频url
      fieldArr: [], //字段
      swiperImg: [],
      is_show_recommend_qrcode: false, //二维码展示
      is_show_des: false, //显示会议介绍
      is_show_meetingPlace: false,
      meetingDes: "",
      scheduleDate: [],
      meetingSchedules: [],
      meetingDays: [], // 新接口-会场日期
      value: 0,
      websock: "",
      obj: "",
      room_id: this.$route.query.id, //房间号
      connectWebSocket: false, //websocket是否连接
      pingTimer: null, //定时器
      topicList: [], //话题列表
      hasAuth: false,
      formset: {},
      theme_color: "",
      is_show_extend: false,
      extend_pop: {},
      show_detail: true,
      more_lines: false,
      line_buttons: [],
      line_index: 0,
      timeout_count: 0,
      nav_title: "",
      schedule_active: 0,
      scheduleDate1: [],
      meetingEndTime: "",
      headTitle: "大会直播",
      isTabsFixed: false,
      tabsOffTop: 0,
      liveInfo2: {},
      weekdays: [],
      shareimg: '',
      is_show_charge: false,
      isWxBtn: false,
      is_show_phone_popup: false,
      updateMobile: '',
      showChooseTime: false,
      is_show_meeting_password: false,
      passwordInputValue: '',
      meeting_watch_password: null,
      meeting_watch_type: 1,
      showPicker: false,
      showPickerAge: false,
      showPickerJob: false,
      showPickerDepart: false,
      customFieldName: {
        value: 'name',
        text: "name"
      },
      options: [
        {
          value: 5,
          label: '5分钟'
        },
        {
          value: 15,
          label: '15分钟'
        },
        {
          value: 30,
          label: '30分钟'
        }
      ],
      columns: [5, 15, 30],
      pre_time: 5,
      subscribe_item: {},
      subscribe_type: 0,
      show_bind_wiki: false,//登录注册medwiki，
      show_collect_username: false,
      show_collect_authInfo: false,
      userAuthInfo: {
        username: '',
        age: '',
        hospital: '',
        depart_name: '',
        job_name: ''
      },
      authAge: '70后',
      authJobName: '',
      authDepartName: '',
      liveStatus: 0,
      jobs: [],
      departs: [],
      ages: [],
      showWantLookTip: false,
      show_zimu_player: false,
      show_zimu_tab: false,
      zimuList: [],
      tabValue: '',
      zimuLang: 'cn',
      displayTextLine: 0,
      showAISummary: false,
      chapterAISummaryInfo: {},
      meeting_id: '',
      _wx: null,
      _checkTopRafId: null,
      _checkTopTimer: null,
      _deferredTimer: null,
      liveRefreshTimer: null, // 直播中每隔15分钟刷新页面
      currentHallWatchType: 1
    };
  },
  computed: {
    hasScheduleDate() {
      return this.scheduleDate1 && this.scheduleDate1.length > 0;
    },
    // banner 封面日程列表：兼容会场名为 name / 唯一 hall key
    bannerChapterList() {
      const dateKey = this.scheduleDate1 && this.scheduleDate1[0];
      if (!dateKey || !this.meetingSchedule) return [];
      const byHall = this.meetingSchedule[dateKey];
      if (!byHall || typeof byHall !== "object") return [];
      if (this.liveDetails && this.liveDetails.name && Array.isArray(byHall[this.liveDetails.name])) {
        return byHall[this.liveDetails.name];
      }
      const halls = Object.keys(byHall);
      if (!halls.length) return [];
      return Array.isArray(byHall[halls[0]]) ? byHall[halls[0]] : [];
    }
  },
  watch: {
    topicList(oldData, newData) {
      this.isEmpty = newData.length > 0 ? false : true;
    }
  },
  beforeRouteEnter(to, from, next) {
    // 修复iOS版微信 HTML5 History 兼容性；路径不一致时整页跳转并中止 SPA 导航
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
      next(false);
    } else {
      next();
    }
  },
  created() {
    if (common.is_weixin()) {
      //微信端
      this.getUserInfo();
    } else {
      //非微信端
      this.userInfo = this.$store.state.userInfo;
      if (this.userInfo) {
        this.getUserInfo();
      } else {
        this.$router.replace({
          path: "/vascularNews/user/login?meeting_id=" + this.meeting_id,
          query: { url: window.location.href }
        });
      }
    }

  },
  mounted() {
    // 添加监听器
    this.checkOrientation();
    window.addEventListener("resize", this.checkElementAtTopDebounced);

  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener("resize", this.checkElementAtTopDebounced);
    if (this._checkTopTimer) clearTimeout(this._checkTopTimer);
    if (this._deferredTimer) clearTimeout(this._deferredTimer);
    if (this._checkTopRafId) cancelAnimationFrame(this._checkTopRafId);
    this.stopLiveRefreshTimer();
  },
  methods: {
    // 直播中未防止直播流中断每隔15分钟刷新页面
    startLiveRefreshTimer() {
      this.stopLiveRefreshTimer();
      this.liveRefreshTimer = setInterval(() => {
        if (this.liveStatus === 1) {
          window.location.reload();
        } else {
          this.stopLiveRefreshTimer();
        }
      }, 15 * 60 * 1000);
    },
    stopLiveRefreshTimer() {
      if (this.liveRefreshTimer) {
        clearInterval(this.liveRefreshTimer);
        this.liveRefreshTimer = null;
      }
    },
    //解决ios页面缓存
    checkIOSAndReload() {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOS && !sessionStorage.getItem('isReloaded')) {
        sessionStorage.setItem('isReloaded', 'true');
        window.location.reload();
      }
    },
    changeTab(val, title) {
      this.tabValue = title
      if (title == '字幕') {
        // this.refreshVideoZimu()
      }
      if (title === '互动讨论') {
        this.ensureWebSocketConnected();
      }
    },
    //切换字幕语言
    changeZimuLang() {
      this.zimuLang = this.zimuLang == 'cn' ? 'en' : 'cn'
    },
    //录播视频字幕
    refreshVideoZimu(vid) {
      if (this.show_zimu_tab) {
        const url = VideoSubtitle;
        let params = {
          id: vid
        };
        const method = "Get";
        fetch(url, params, method).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.zimuList = data

          }
        });
      }

    },
    updateZimu(info) {
      if (info.index == this.displayTextLine && this.zimuList.length > 0) {
        this.zimuList[this.zimuList.length - 1].content = this.zimuList[this.zimuList.length - 1].content + info.text + info.punc
      } else {
        this.zimuList.push({
          content: info.text + info.punc,
          time: info.time
        })
      }
      this.displayTextLine = info.index
    },
    initPageScroll(id) {
      if (!id) return;
      var element = document.getElementById(id);
      if (!element) return;
      var container = document.querySelector(".meeting-live1") || document.querySelector(".container");
      try {
        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      } catch (e) {
        try { element.scrollIntoView(true); } catch (err) { /* ignore */ }
      }
      if (container && container.scrollHeight > container.clientHeight) {
        var top = container.scrollTop + element.getBoundingClientRect().top;
        if (typeof container.scrollTo === "function") {
          try {
            container.scrollTo({ top: Math.max(0, top), left: 0, behavior: "smooth" });
          } catch (e) {
            container.scrollTop = Math.max(0, top);
          }
        } else {
          container.scrollTop = Math.max(0, top);
        }
      }
    },
    checkElementAtTopDebounced(e) {
      // console.log('resize')
      if (this._checkTopTimer) clearTimeout(this._checkTopTimer);
      this._checkTopTimer = setTimeout(() => this.checkElementAtTop(e), 80);

    },
    checkElementAtTop(e) {
      if (this._checkTopRafId) cancelAnimationFrame(this._checkTopRafId);
      this._checkTopRafId = requestAnimationFrame(() => {
        let element = document.getElementById("video");
        let element2 = document.getElementById("top");
        if (!element) return;
        let height = element.offsetHeight;
        if (element2) {
          height += element2.offsetHeight;
        }
        this.tabsOffTop = height;
        if (e && window.innerWidth < 900) {
          setTimeout(() => {
            this.isTabsFixed = true;
          }, 50);
        } else {
          this.isTabsFixed = false;
        }
        this.checkOrientation();
      });
    },
    checkOrientation() {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // 判断宽高比，如果宽度大于高度则为横屏
      this.isLandscape = width >= height;
      // console.log('isLandscape', this.isLandscape)

      if (this.isLandscape) {
        this.isTabsFixed = false;
      }

    },
    onClickLeft() {
      this.$router.go(-1);
    },
    showChargePopup() {
      this.is_show_charge = true
    },
    goHome() {
      this.$router.push({
        path: "/vascularNews/meeting/index",
        query: {
          meeting_id: this.meeting_id
        }
      });
    },
    //注册收费观看
    goRegisterCharge() {
      // 创建一个表示2024年8月28日0点的时间对象
      const targetDate = new Date("2024-08-28T00:00:00");
      // 获取当前时间
      const currentDate = new Date();
      // 判断当前时间是否在目标时间之后
      const isAfterTargetDate = currentDate > targetDate;
      console.log('当前时间是否在2024年8月28日0点之后:', isAfterTargetDate);
      if (isAfterTargetDate) {
        this.is_show_charge = false;
        setTimeout(() => {
          common.toast('注册报名已结束', 2000);
        }, 10)

      } else {
        this.$router.push({
          path: "/vascularNews/meeting/charge",
          query: {
            meeting_id: this.meeting_id
          }
        });
      }

    },
    //得到用户信息
    getUserInfo() {
      const url = PersoanalUserInfo;
      let params = {};
      const method = "POST";
      fetch(url, params, method)
        .then(res => {
          if (res && res.code == 0) {
            let data = res.data;
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            this.userInfo = data;
            if (this.userInfo && this.userInfo.mobile_status == 1) {
              this.id = this.$route.query.id;
              this.meeting_id = this.$route.query.meeting_id
                ? this.$route.query.meeting_id
                : this.$route.query.MT_id;
              this.getActivities();
            } else {
              common.toast("未绑定手机", 1000, "fail", () => {
                this.$router.replace({
                  path: "/vascularNews/user/login?meeting_id=" + this.meeting_id,
                  query: { url: window.location.href }
                });
              });
            }
          } else if (!res || res.code != 602) {
            // 602 由全局拦截器处理授权；其他失败给出提示，避免 hasAuth 一直 false 白屏
            Toast.fail((res && res.error_msg) || "加载失败，请刷新重试");
          }
        })
        .catch(() => {
          Toast.fail("加载失败，请刷新重试");
        });
    },
    subscribeTime(val) {
      this.showChooseTime = val > 0 ? true : false
    },
    showWantLook() {
      this.showWantLookTip = true
      setTimeout(() => {
        this.showWantLookTip = false
      }, 2000)
    },
    //活动
    getActivities() {
      const url = MeetingsCollectInfo;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method)
        .then(res => {
          if (res && res.code == 0) {
            let data = res.data;
            if (data.extend_columns && data.extend_columns.length != 0) {
              this.fieldArr = data.extend_columns;
              this.showActivity = Boolean(data.extend_columns.length);
              this.formset = data.formset;
            } else {
              this.hasAuth = true;
              // 首屏关键：会场详情（视频/日程/标题）
              this.getMeetingsPlaceDetails();

              // 非首屏关键：延后到首屏渲染后再请求，减少打开阻塞
              this._deferredTimer = setTimeout(() => {
                this.getMeetingsPlace();
                this.getMeetingNumer();
                this.getBanner();
                this.getExtend();
                this.getDeparts();
              }, 0);
            }
            // WebSocket 签名与连接延后：切到“互动讨论”再初始化
          } else {
            if (res && res.code == 501) {
              this.hasAuth = false;
            } else if (!res || res.code != 602) {
              Toast.fail((res && res.error_msg) || "加载失败，请刷新重试");
            }
          }
        })
        .catch(() => {
          Toast.fail("加载失败，请刷新重试");
        });
    },
    closePop() {
      this.showActivity = false;
    },
    //切换日期（顶部日期展示用；日程切换由 Schedule 组件内部处理）
    switchDate(date) {
      if (!date) return;
      this.scheduleDate1 = Object.keys(this.meetingSchedule || {});
      this.schedule_active = date;
    },
    /**
     * 去注册
     */
    goRegister() {
      this.$router.push({
        path: "/user/register"
      });
    },
    //认证
    goWikiLogin() {
      fetch(RegisterWiki, {}, 'POST')
        .then((res) => {
          if (res.code == 0) {
            this.show_bind_wiki = false
            if (this.liveDetails.collect_user_profile) {
              this.userAuthInfo = this.liveDetails.collect_user_profile
            }
            //判断认证信息填写完全
            if (!(this.userAuthInfo && this.userAuthInfo.age && this.userAuthInfo.username && this.userAuthInfo.job_name && this.userAuthInfo.hospital && this.userAuthInfo.depart_name)) {
              this.show_collect_authInfo = true
            }

          }

        })
      // window.location.href = 'https://med.wiki/web/login?xgzx_user_id=' + this.userInfo.id + '&callback=' + encodeURIComponent(window.location.href)
    },
    onConfirm(val) {
      this.pre_time = val;
      this.showPicker = false
    },
    // canvasToShareImg(val){
    //   console.log('coverimg',val)
    //   this.shareimg=val
    // },
    //会场详情（新接口：会场详情 + 会场日程 + 会议信息并行请求）
    getMeetingsPlaceDetails() {
      this.$store.dispatch("isShowLoading", true);
      const chapterId = this.$route.query.chapter_id
        ? this.$route.query.chapter_id
        : this.$route.query.c_id;
      const detailReq = fetch(NewSessionDetail(this.meeting_id, this.id), {}, "GET");
      const chapterParams = {};
      if (chapterId) chapterParams.chapter_id = chapterId;
      const chapterReq = fetch(
        NewSessionChapter(this.meeting_id, this.id),
        chapterParams,
        "GET"
      );
      const meetingReq = fetch(NewMeetingDetail(this.meeting_id), {}, "GET").catch(
        () => ({ code: -1, data: null })
      );

      // 详情失败才失败；日程/会议信息失败不阻断首屏播放
      Promise.all([
        detailReq,
        chapterReq.catch(() => ({ code: -1, data: null })),
        meetingReq
      ])
        .then(([detailRes, chapterRes, meetingRes]) => {
          // console.log('detailRes',detailRes.data,meetingRes.data)
          if (!detailRes || detailRes.code != 0) {
            this.$store.dispatch("isShowLoading", false);
            if (!detailRes || detailRes.code != 602) {
              Toast.fail((detailRes && detailRes.error_msg) || "加载失败，请刷新重试");
            }
            return;
          }
          const session = detailRes.data || {};
          // 新接口会场详情可能不带 meeting，用会议详情接口补齐
          if (!session.meeting && meetingRes && meetingRes.code == 0) {
            session.meeting = meetingRes.data || {};
          }
          if (!session.meeting) session.meeting = {};
          this.applySessionDetail(session);
          this.applyMeetingAccess(session);//大会权限判断

          const chaptersRaw =
            (chapterRes && chapterRes.code == 0 && chapterRes.data) ||
            (detailRes.data && detailRes.data.chapters) ||
            {};
          const chaptersData =
            chaptersRaw.chapters != null ? chaptersRaw.chapters : chaptersRaw;
          this.meetingSchedule = this.normalizeChapters(chaptersData, session);
          if (this.meetingSchedule && Object.keys(this.meetingSchedule).length) {
            this.scheduleDate1 = Object.keys(this.meetingSchedule);
            this.switchDate(this.scheduleDate1[0]);
          }

          if (this.liveDetails.daily_preview_title || this.liveDetails.name) {
            let title = this.liveDetails.daily_preview_title
              ? this.liveDetails.daily_preview_title
              : this.liveDetails.name;
            if (this.scheduleDate1 && this.scheduleDate1.length) {
              title = this.scheduleDate1[0] + title;
            }
            if (this.liveDetails.hall_name) {
              title = title + "(" + this.liveDetails.hall_name + ")";
            }
            this.headTitle = title;
          }

          this.admin = session.admin || [];
          // 浏览器标题使用会议厅名
          document.title = session.hall_name
            || session.daily_preview_title
            || session.name
            || "大会直播";
          if (common.is_weixin()) {
            let share_info = {};
            if (
              (this.$route.query.chapter_id || this.$route.query.c_id) &&
              this.meetingSchedule &&
              Object.keys(this.meetingSchedule).length
            ) {
              let date = Object.keys(this.meetingSchedule)[0];
              let obj = this.meetingSchedule[date];
              obj = obj[Object.keys(obj)[0]];
              share_info = {
                title: obj && obj[0] ? obj[0].name : session.name,
                desc: session.name,
                img: session.shareimg
              };
            } else {
              share_info = {
                title: session.name,
                desc: session.share_sub_title,
                img: session.shareimg
              };
            }
            this.$nextTick(() => {
              this.getWxConfig(share_info);
            });
          }

          this.$store.dispatch("isShowLoading", false);
        })
        .catch(() => {
          this.$store.dispatch("isShowLoading", false);
          Toast.fail("加载失败，请刷新重试");
        });
    },
    // 应用会场详情数据（播放器 / 权限 / 字幕等）
    applySessionDetail(session) {
      this.liveDetails = session;
      console.log('liveDetails', this.liveDetails)
      if (this.liveDetails.meeting.mobile_status == 0) {
        this.is_show_phone_popup = true;
      }
      this.is_show_recommend_qrcode = this.liveDetails.is_show_recommend_qrcode
        ? true
        : false;
      this.is_show_des = this.liveDetails.is_show_des;
      // 无企业专区或空数组时展示「切换会场」（新接口可能省略 company_areas）
      const areas = this.liveDetails.company_areas;
      if (!areas || (Array.isArray(areas) && areas.length === 0)) {
        this.is_show_meetingPlace = true;
      }
      if (this.liveDetails && this.liveDetails.des) {
        this.meetingDes = this.liveDetails.des;
      } else {
        this.meetingDes = (this.liveDetails.meeting && this.liveDetails.meeting.des) || "";
      }

      if (
        this.liveDetails &&
        this.liveDetails.lines &&
        Object.keys(this.liveDetails.lines).length > 1
      ) {
        this.more_lines = true;
        this.line_buttons = [];
        let keys = Object.keys(this.liveDetails.lines);
        for (let i = 0; i < keys.length; i++) {
          this.line_buttons.push(this.liveDetails.lines[keys[i]]);
          if (i == 0) {
            this.liveDetails.play_url_m3u8 = this.liveDetails.lines[
              keys[i]
            ].play_url_m3u8;
          }
        }
      }

      if (session && session.hidden_details == 1) {
        this.show_detail = false;
      }

      this.liveInfo2 = session;
      let hasApplied = false;
      const applyOnce = () => {
        if (hasApplied) return true;
        if (this.applyLiveInfoToPlayer(this.liveInfo2)) {
          hasApplied = true;
          return true;
        }
        return false;
      };
      this.$nextTick(() => applyOnce());
      let retryCount = 0;
      const tryApply = () => {
        if (applyOnce()) return;
        if (retryCount < 15) {
          retryCount++;
          setTimeout(tryApply, 80);
        }
      };
      setTimeout(tryApply, 100);

      if (session.meeting && session.meeting.bind_wiki_status && !session.meeting.bind_wiki_user_status) {
        this.show_bind_wiki = true;
      }
      var extentInfo =
        this.liveDetails.meeting && this.liveDetails.meeting.extra_data;
      // console.log('extentInfo',extentInfo)
      // 字幕显示
      if (extentInfo && extentInfo.subtitle_status == 1) {
        var subtitlePos = extentInfo.subtitle_pos || "";
        if (subtitlePos.indexOf("1") > -1) {
          this.show_zimu_player = true;
        }
        if (subtitlePos.indexOf("2") > -1) {
          this.show_zimu_tab = true;
        }
        if (extentInfo.subtitle_lang_type) {
          this.zimuLang = extentInfo.subtitle_lang_type;
        }
      }

      if (session.end_at && session.start_at) {
        let meeting_end_time = session.end_at;
        let meeting_start_time = session.start_at;
        let arr1 = meeting_start_time.split(/[- : /]/);
        this.liveStartTime = new Date(
          arr1[0],
          arr1[1] - 1,
          arr1[2],
          arr1[3],
          arr1[4],
          arr1[5]
        ).getTime();
        let arr2 = meeting_end_time.split(/[- : /]/);
        this.liveEndTime = new Date(
          arr2[0],
          arr2[1] - 1,
          arr2[2],
          arr2[3],
          arr2[4],
          arr2[5]
        ).getTime();
        this.currentTime = new Date().getTime();
        if (this.currentTime > this.liveEndTime) {
          this.liveStatus = 2;
          this.stopLiveRefreshTimer();
          console.log('会议结束')
        } else if (this.currentTime < this.liveStartTime) {
          this.liveStatus = 0;
          this.stopLiveRefreshTimer();
          console.log('会议未开始')
        } else {
          this.liveStatus = 1;
          console.log('会议进行中')
        }
      }

      if (session.meeting && session.meeting.bind_wiki_status && session.meeting.bind_wiki_user_status) {
        if (session.meeting.collect_user_profile) {
          this.userAuthInfo = session.meeting.collect_user_profile;
        }
        this.show_bind_wiki = false;
        if (
          !(
            this.userAuthInfo &&
            this.userAuthInfo.age &&
            this.userAuthInfo.username &&
            this.userAuthInfo.job_name &&
            this.userAuthInfo.hospital &&
            this.userAuthInfo.depart_name
          )
        ) {
          this.show_collect_authInfo = true;
        }
      }

      // 主题色优先从会场/会议详情取，避免等切换会场接口
      const meeting = session.meeting || {};
      if (meeting.theme_color_hex) {
        this.theme_color = meeting.theme_color_hex;
      } else if (session.theme_color_hex) {
        this.theme_color = session.theme_color_hex;
      }
      if (meeting.schedule_color_hex) {
        this.schedule_color = meeting.schedule_color_hex;
      }
      if (meeting.schedule_font_color_hex) {
        this.schedule_font_color = meeting.schedule_font_color_hex;
        if (!session.schedule_font_color_hex) {
          this.$set(this.liveDetails, "schedule_font_color_hex", meeting.schedule_font_color_hex);
        }
      }
      if (meeting.end_at) {
        this.meetingEndTime = meeting.end_at;
      }
      // 保证 extent_info 存在，避免字幕/想看等逻辑读空
      // if (!this.liveDetails.meeting) {
      //   this.$set(this.liveDetails, "meeting", meeting);
      // } else if (!this.liveDetails.meeting.extent_info) {
      //   this.$set(
      //     this.liveDetails.meeting,
      //     "extent_info",
      //     meeting.extent_info || {}
      //   );
      // }
    },
    // 将新日程接口数据适配为 Schedule 组件所需结构：{ 日期: { 会场名: [章节] } }
    normalizeChapters(data, session) {
      if (!data) return {};
      const hallName =
        (session && (session.name || session.daily_preview_title)) || "会场";
      const fallbackDate = this.formatSessionDayName(session) || "日程";

      let result = {};
      if (Array.isArray(data)) {
        result = { [fallbackDate]: { [hallName]: data } };
      } else if (typeof data !== "object") {
        return {};
      } else {
        const keys = Object.keys(data);
        if (!keys.length) return {};

        const firstVal = data[keys[0]];
        // 已是 { 日期: { 会场: [...] } }
        if (
          firstVal &&
          typeof firstVal === "object" &&
          !Array.isArray(firstVal)
        ) {
          const innerKeys = Object.keys(firstVal);
          if (innerKeys.length && Array.isArray(firstVal[innerKeys[0]])) {
            result = data;
          } else if (innerKeys.length && firstVal.name) {
            // { 日期: 章节对象 } → 包一层会场名
            keys.forEach(date => {
              result[date] = { [hallName]: [data[date]] };
            });
          } else {
            result = {};
          }
        } else if (Array.isArray(firstVal)) {
          // { 日期: [...] }
          keys.forEach(date => {
            result[date] = { [hallName]: data[date] };
          });
        } else if (Array.isArray(data.list)) {
          result = { [fallbackDate]: { [hallName]: data.list } };
        } else if (Array.isArray(data.chapters)) {
          result = { [fallbackDate]: { [hallName]: data.chapters } };
        } else {
          result = {};
        }
      }

      return this.sanitizeChapterTree(result, session);
    },
    // 补齐 Schedule 依赖的空数组字段，避免 .length 读 undefined 报错
    sanitizeChapterTree(tree, session) {
      if (!tree || typeof tree !== "object") return {};
      Object.keys(tree).forEach(date => {
        const halls = tree[date];
        if (!halls || typeof halls !== "object") return;
        Object.keys(halls).forEach(hall => {
          const list = halls[hall];
          if (!Array.isArray(list)) {
            halls[hall] = [];
            return;
          }
          halls[hall] = list.map(ch => this.sanitizeChapterItem(ch, session));
        });
      });
      return tree;
    },
    sanitizeChapterItem(ch, session) {
      if (!ch || typeof ch !== "object") return ch;
      const item = ch;
      if (!Array.isArray(item.chairman_writers)) item.chairman_writers = [];
      if (!Array.isArray(item.host_writers)) item.host_writers = [];
      if (!Array.isArray(item.discussor_writers)) item.discussor_writers = [];
      if (!Array.isArray(item.details)) item.details = [];
      if (!Array.isArray(item.titles)) item.titles = [];
      if (!item.session) {
        item.session = {
          id: (session && session.id) || this.id,
          name: (session && session.name) || ""
        };
      }
      return item;
    },
    formatSessionDayName(session) {
      if (!session || !session.start_at) return "";
      const datePart = String(session.start_at).split(" ")[0];
      const parts = datePart.split("-");
      if (parts.length >= 3) {
        return parseInt(parts[1], 10) + "月" + parseInt(parts[2], 10) + "日";
      }
      return "";
    },
    getDeparts() {
      const method = "POST";
      fetch(MeetingsAuthList, {}, method)
        .then((res) => {
          if (res.code == 0) {
            this.departs = res.data.departs;
            this.ages = res.data.ages;
            this.jobs = res.data.jobs;
          }
        })
    },
    onSelectAge(val) {
      this.userAuthInfo.age = val.name;
      this.showPickerAge = false

    },
    onSelectJob(val) {
      this.userAuthInfo.job_name = val.name;
      this.showPickerJob = false

    },
    onSelectDepart(val) {
      this.userAuthInfo.depart_name = val.name;
      this.showPickerDepart = false

    },
    //提交认证信息
    submitAuthInfo() {
      if (!(this.userAuthInfo.username && this.userAuthInfo.age && this.userAuthInfo.hospital && this.userAuthInfo.depart_name && this.userAuthInfo.job_name)) {
        Toast.fail('请完整并正确输入');
        return;
      }
      let params = {
        session_id: this.liveDetails.id,
        age: this.userAuthInfo.age,
        username: this.userAuthInfo.username,
        hospital: this.userAuthInfo.hospital,
        job_name: this.userAuthInfo.job_name,
        depart_name: this.userAuthInfo.depart_name
      }
      const method = "POST";
      fetch(CollectUserAuth, params, method)
        .then((res) => {
          if (res.code == 0) {
            this.show_collect_authInfo = false;
            this.show_collect_username = false;
            Toast('提交成功');


          }
        })
    },
    // meeting_id=490提交手机号
    submitPhone() {
      if (this.updateMobile && this.updateMobile.length == 11) {
        let params = {
          mobile: this.updateMobile
        }
        const method = "POST";
        fetch(UpdateUserInfo, params, method)
          .then((res) => {
            if (res.code == 0) {
              this.is_show_phone_popup = false;
              Toast('提交成功');
              setTimeout(() => {
                location.reload()
              }, 1000)

            }
          })
      } else {
        Toast.fail('请正确输入', err);
      }
    },
    //会议密码验证
    confirmMeetingPwd() {
      if (this.meeting_watch_type == 2) {
        if (this.meeting_watch_password == this.passwordInputValue) {
          this.is_show_meeting_password = false
          Toast('密码正确');
        } else {
          Toast('密码输入错误');

        }
      } else if (this.currentHallWatchType == 2) {
        let params = {
          pwd: this.passwordInputValue,
          id: this.id,
          type_name: 'session'
        }
        const method = "POST";
        fetch(NewMeetingVerifyPwd(), params, method)
          .then((res) => {
            if (res.code == 0 && res.data.status ) {
              this.is_show_meeting_password = false
              Toast('密码正确');
            }else{
              Toast('密码输入错误');
            }
          })
      }

    },
    async getWxConfig(share_info) {
      let that = this
      if (common.is_weixin()) {
        if (!this._wx) {
          const mod = await import('weixin-js-sdk')
          this._wx = mod && mod.default ? mod.default : mod
        }
        const wx = this._wx
        const url = WxShare;
        let params = {
          "jssdk": ["wx-open-launch-weapp", 'onMenuShareAppMessage', 'onMenuShareTimeline', 'wx-open-subscribe'],
          "url": location.href
        };
        const method = 'POST';
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              wx.config({
                debug: false, // 验证结果弹窗控制，微信环境可能会因为接口安全问题出现失败弹窗，所以直接设置的false，
                appId: res.data.appId, // 公众号唯一appid
                nonceStr: res.data.nonceStr,
                timestamp: res.data.timestamp,
                signature: res.data.signature,
                jsApiList: res.data.jsApiList,//随便填写的一个
                openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app', 'wx-open-subscribe']
              })
              wx.ready(function (success) {
                that.isWxBtn = true //表示验证成功
                //分享给朋友
                wx.onMenuShareAppMessage({
                  title: share_info.title, // 分享标题
                  desc: share_info.desc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: common.normalizeWeChatShareImgUrl(share_info.img), // 分享图标
                  type: 'link', // 分享类型,music、video或link，不填默认为link
                  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                  success: function () {
                    // 用户确认分享后执行的回调函数


                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                //分享到朋友圈
                wx.onMenuShareTimeline({
                  title: share_info.title,
                  link: window.location.href,
                  imgUrl: common.normalizeWeChatShareImgUrl(share_info.img),
                  // type: 'link',
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                console.log('success', success)
              })
              wx.error(function (err) {
                // Toast.fail('暂不支持', err);
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.log('error', err)
              })


            }
          })

      }
    },
    getLiveInfo() {
      this.applyLiveInfoToPlayer(this.liveInfo2, 'play');
    },
    applyLiveInfoToPlayer(session, playFlag) {
      if (this.$refs.player && typeof this.$refs.player.getLiveInfo === 'function') {
        this.$refs.player.getLiveInfo(session || this.liveInfo2, playFlag || null);
        return true;
      }
      return false;
    },
    submitSubscribe() {
      this.$refs.schedule.submitSubscribe();

    },
    //打开日程AI摘要
    showChargeAISummary(info) {
      console.log(info)
      this.chapterAISummaryInfo = info
      this.showAISummary = true
    },
    //会议广告位
    getBanner() {
      const url = MeetingBanner;
      const method = "POST";
      let params = {
        session_id: this.id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.swiperImg = data;
        }
      });
    },
    changeLine(item, index) {
      if (index != this.line_index) {
        this.liveDetails["play_url_m3u8"] = item.play_url_m3u8;
        this.$nextTick(() => this.applyLiveInfoToPlayer(this.liveDetails));
        this.line_index = index;
      }
    },
    //会议弹出
    getExtend() {
      const url = extendPop;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.extend_pop = data;
          // if(true){
          if (data.live_alter_ad) {
            this.is_show_extend = true;
          }
        }
      });
    },
    changeInfoStatus(data) {
      this.showActivity = data;
    },
    //会场日期列表（会议详情已在 getMeetingsPlaceDetails 中拉取，避免重复请求）
    getMeetingsPlace() {
      fetch(NewMeetingDays(this.meeting_id), {}, "GET").then(res => {
        if (res.code == 0) {
          this.meetingDays = res.data || [];
        }
      });
    },
    // 观看权限 / 主题色等会议级配置
    applyMeetingAccess(info) {
      if (!info) return;
      var data = info.meeting || {};
      var that = this;
      //大会观看权限(一整个大会)
      if (data.extra_data && data.extra_data.watch_type == 3 && !data.extra_data.white_list_user) {
        Dialog({
          title: "温馨提示",
          message: data.extra_data.white_visit_tip,
          confirmButtonText: "确定"
        })
          .then(() => {
            if (window.history.length > 1) {
              that.$router.go(-1);
            } else {
              that.$router.replace(
                "/vascularNews/meeting/index?meeting_id=" + that.meeting_id
              );
            }
          })
          .catch(() => { });
      } else if (data.extra_data && data.extra_data.watch_type == 2) {
        this.is_show_meeting_password = true;

      } else if (data.extra_data && data.extra_data.watch_type == 1 && info.extend_fields && info.extend_fields.watch_type != 1) {
        //会场观看权限(单个会场)
        console.log('会场观看权限', info.extend_fields.watch_type, info.user_white_list_status)
        if (info.extend_fields.watch_type == 3 && !info.user_white_list_status) {
          Dialog({
            title: "温馨提示",
            message: info.extend_fields.white_visit_tip,
            confirmButtonText: "确定"
          })
            .then(() => {
              if (window.history.length > 1) {
                that.$router.go(-1);
              } else {
                that.$router.replace(
                  "/vascularNews/meeting/index?meeting_id=" + that.meeting_id
                );
              }
            })
            .catch(() => { });
        } else if (info.extend_fields.watch_type == 2) {
          this.is_show_meeting_password = true;
          this.currentHallWatchType = 2
        }
      }

      this.meeting_watch_type = data.extra_data.watch_type;//会议
      this.currentHallWatchType = info.extend_fields.watch_type;//会场
      this.meeting_watch_password = data.watch_password;
      console.log('大会观看权限',this.meeting_watch_type)
      if (data.theme_color_hex) {
        this.theme_color = data.theme_color_hex;
      } else if (!this.theme_color) {
        this.theme_color = "#901D22";
      }
      if (data.schedule_color_hex) {
        this.schedule_color = data.schedule_color_hex;
      }
      if (data.schedule_font_color_hex) {
        this.schedule_font_color = data.schedule_font_color_hex;
      }
      if (data.end_at) {
        this.meetingEndTime = data.end_at;
      }
    },
    //会议观看人数
    getMeetingNumer() {
      const url = SessionsViewsNum;
      let params = {
        session_id: this.id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.viewNum = data.views;
        }
      });
    },
    clickSwiperImg(item) {
      window.location.href = item.url;
    },
    changeAuth(data) {
      this.hasAuth = data;
      if (data == true) {
        this.getMeetingsPlaceDetails();
        this.getMeetingsPlace();
        this.getMeetingNumer();
        this.getBanner();
        this.getExtend();
        this.getDeparts();
      }
    },
    //返回
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/vascularNews/meeting/index?meeting_id=' + this.meeting_id)
      }
    },
    //得到签名
    getSignature() {
      if (Object.keys(this.signatureInfo).length == 0) {
        const url = Signature;
        const method = "POST";
        let params = {
          scheme: window.location.protocol
        };
        fetch(url, params, method).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.signatureInfo = data;
            if (!this.userInfo) {
              this.getUserInfo();
            } else {
              this.initWebSocket();
            }
          }
        });
      } else {
        if (!this.userInfo) {
          this.getUserInfo();
        }
      }
    },
    ensureWebSocketConnected() {
      if (this.connectWebSocket || this.websock) return;
      this.getSignature();
    },
    //初始化weosocket
    initWebSocket() {
      // const wsuri = "ws://ws.talkmed.com/xgzx-pro?platform="+platform+"&timestamp="+timestamp+"&uasid="+uasid+"&signature="+signature+"&nickname="+nickname+"&avatar="+avatar;
      const wsuri = this.signatureInfo.ws_url;

      this.websock = new WebSocket(wsuri);
      this.websock.onopen = data => {
        console.log("连接成功");
      };
      this.websock.onmessage = event => {
        this.websocketonmessage(event);
      };
      this.websock.onerror = () => {
        if (this.timeout_count < 5) {
          this.timeout_count++;
          console.log("连接失败，等待15s尝试重连" + this.timeout_count);
          setTimeout(() => {
            this.websocketonerror();
          }, 15000);
        }
      };
      this.websock.onclose = () => {
        this.websocketclose();
      };
    },
    //数据发送
    websocketSendMessage() {
      let params = {
        action: "send_to_all_room_member",
        params: {
          raw: {
            body: this.content
          }
        },
        room_id: this.room_id
      };
      this.websock.send(JSON.stringify(params));
      this.content = "";
    },
    //连接建立失败重连
    websocketonerror() {
      this.initWebSocket();
    },
    //数据接收
    websocketonmessage(res) {
      if (res.data == "pong") return;
      var data = JSON.parse(res.data);
      //连接成功  加入房间
      if (data.code == 201) {
        this.joinRoom();
        this.connectWebSocket = true;
        this.keepSocket();
      } else if (data.code == 200) {
        //正常响应
        // console.log(data.action);
        let str = data.action;
        let userId = this.userInfo ? this.userInfo.ecs_id : 0;
        switch (str) {
          //接收到群发信息
          case "send_to_all_room_member":
            let receiveData = data.data.msg_list[0];
            let obj = {
              avatar: receiveData.avatar,
              msg: `<i>${receiveData.nickname} :</i> ${receiveData.body}`,
              direction: userId == receiveData.from_id ? "right" : "left"
            };
            this.topicList.push(obj);
            // this.backBottom();
            break;
          //消息正在审核中
          case "wait_check_msg":
            common.toast(data.message, 1500);
            break;
        }
      } else if (data.code == 301 || data.code == 403) {
        //被迫下线  签名错误或者验证已过期
        this.getSignature();
      }
    },
    //关闭websocket
    websocketClose() {
      this.websock.close();
    },
    //加入房间
    joinRoom() {
      let nickname = this.userInfo.nickname;
      let avatar = this.userInfo.avatar;
      let obj = {
        type: "room",
        action: "join_room",
        params: {
          nickname: nickname,
          avatar: avatar
        },
        room_id: this.room_id
      };
      this.websock.send(JSON.stringify(obj));
    },
    //  维持心跳  WebSocket Ping Pong
    keepSocket() {
      console.log("ping");
      if (this.connectWebSocket) {
        this.websock.send("ping");
      }
      this.pingTimer = setTimeout(() => {
        this.keepSocket();
      }, 1000 * 30);
    },
    websocketclose(e) {
      console.log("断开连接", e);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
    //退出这个页面  录播url为空
    this.$store.dispatch("receiveVideoUrl", "");
    //建立连接  才可以关闭
    if (this.connectWebSocket) {
      clearTimeout(this.pingTimer);
      this.websocketClose();
    }
  }
};

</script>

<style lang="scss" scoped>
.popup-box {
  padding: 0 20px;
  text-align: center;
  color: #a21016;
  background-image: url('/assets/images/cec2022/med_conference.png');
  background-size: 70% auto;
  background-position: 100% 40%;
  background-repeat: no-repeat;

  h2 {
    margin: 5px 0;
    padding: 0 10px;
    white-space: nowrap;
  }

  .yellowbd {
    border: 3px solid #ce9f70;
    border-radius: 15px;
  }

  button {
    margin: 10px 0;
    padding: 0px 40px;
    border: 3px solid #ce9f70;
    background: white;
    font-weight: 500;
    color: #a21016;
    border-radius: 20px;
    font-size: 16px;
    line-height: 36px;
  }

  /deep/.van-popup__close-icon--top-right {
    top: 0 !important;
    right: 0 !important;
  }
}

.meeting-live1 {
  display: flex;
  flex-direction: column;
  position: relative;

  .all {
    display: flex;
    width: 100%;
    min-height: calc(100vh - 50px);
    flex-flow: column;
  }

  .video {
    position: relative;
    display: flex;
    flex-direction: column;

    .viewNumber {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background: rgba(17, 17, 17, 0.4);
    }

    h3 {
      font-size: 15px;
      color: $color-black;
      flex: 1;
    }
  }

  .swiper-img {
    width: 100%;
    background-color: #fff;

    img {
      width: 100% !important;
    }
  }

  .container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;

  }

  .van-popup {
    border-radius: 5px;
  }

  .activity {
    text-align: center;
    padding: 25px 20px;
    background: linear-gradient(2deg,
        rgba(255, 250, 248, 1) 0%,
        rgba(255, 255, 255, 1) 100%);
    box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.14);
    border-radius: 11px;

    .van-popup__close-icon--top-right {
      font-size: 20px;
      color: #030303;
      top: 10px;
      right: 10px;
    }

    img {
      width: 240px;
      margin: 20px 0;
    }

    button {
      margin: 0 auto;
      width: 165px;
      height: 40px;
      border: 0px;
      background: linear-gradient(180deg,
          rgba(255, 124, 129, 1) 0%,
          rgba(245, 42, 42, 1) 100%);
      box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.14);
      border-radius: 22px;
      // font-size:16px;
      // color:#fff;
      text-shadow: 0px 5px 11px rgba(0, 0, 0, 0.14);

      p {
        display: flex;
        color: #fff;
      }
    }

    >p {
      width: 90%;
      margin: 25px auto;
      text-align: justify;
    }
  }

  .qrcode {

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 70%;
      height: 70%;
    }
  }

  @media screen and (min-width: 768px) {
    .qrcode {
      height: 6rem !important;
      width: 6rem !important;
    }
  }

  .extend {
    padding: 10px 20px;
    display: flex;

    .half {
      width: 50%;
      height: 100%;
      position: relative;

      .attention {
        font-size: 0.58rem;
        font-weight: bold;
        border-bottom: 5px solid #901d22;
        margin-left: 7px;
      }
    }

    img {
      position: absolute;
      top: 50%;
      left: 0px;
      transform: translate(0, -50%);
      width: 80%;
    }

    .extend-content {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  .meeting_des {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    img {
      display: block;
      width: 100% !important;
    }
  }

  // 领取礼物
  .receiveGifts {
    @include flex(row);
    align-items: center;
    position: fixed;
    right: 0px;
    bottom: 60px;
    width: 82px;
    height: 44px;
    background: rgba(244, 103, 45, 1);
    box-shadow: 0px 4px 10px 0px rgba(53, 19, 18, 0.27);
    border-radius: 100px 0px 0px 100px;

    img {
      width: 60px;
      position: absolute;
      left: -12px;
    }

    p {
      margin-left: 45px;
      font-size: 11px;
      color: #fff;
      text-align: center;
      text-shadow: 0px 1px 1px rgba(152, 54, 10, 0.46);
    }
  }
}

.timeTabs-wrap {
  overflow: hidden;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0px 10px 0 8px;
  height: 59px;
  justify-content: flex-start;

  .nav-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .timeTabs-wrap-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    margin: 0 6px;
  }

  h3 {
    font-size: 15px;
    font-weight: 500;
    // flex: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
}

.fixed {
  position: fixed;
  top: 0px;
  z-index: 1000;
}

.timeTabs {
  // padding: 0 12px;
  // height: 60px;
  @include flex(row);
  align-items: center;
  overflow: auto;
  flex-shrink: 0;
  // width: 100%;
  // border-bottom: 1px solid #bfbfbf;

  .tab-item {
    font-size: 14px;
    color: #fff;
    width: 70px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    // border: 1px solid #666;
    border-radius: 2px;
    margin-right: 15px;
  }

  .active {
    color: #fff;
    background: #901d22;
    border: 0px;
  }
}

.bgCover2 {
  border-radius: 5px 5px 0 0;
  width: 100%;
  position: relative;
  overflow: hidden;

  img {
    min-height: 110px;
    background-color: #fff;
    width: 100%;
  }

  ul {
    position: absolute;
    top: 0;
    bottom: 15px;
    padding: 22px;
    overflow: hidden;
    width: 100%;

    li,
    p {
      font-size: 14px;
      margin: 7px 0;
    }

    li span {
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #1a1a1a;
      border-radius: 50%;
      margin-right: 5px;
      vertical-align: middle;
    }
  }

  @media screen and (min-width: 768px) {
    ul {
      padding: 7% !important;
    }
  }
}

.icon_charge_top {
  width: 56px;
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 99999;
  padding-bottom: 220px;

}

.icon_charge_top.sp {
  padding-bottom: 250px;

}

.charge {
  padding: 20px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;

  .filter {
    position: absolute;
    left: -10%;
    top: -20px;
    width: 120%;
    height: 25%;
    opacity: 0.4;
    background: #901D22;
    filter: blur(20px);
  }



  h4 {
    margin: 20px 10px;
    font-size: 18px;
    font-weight: 500;
  }

  h3 {
    margin: 0px 10px 20px;
    font-size: 18px;
    font-weight: 500;
  }

  p {
    color: #666;
    font-size: 15px;
    text-align: center;
  }

  .handles {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;

    div {
      width: 115px;
      height: 42px;
      font-size: 16px;
      line-height: 42px;
      text-align: center;
      border-radius: 5px;
      color: #fff;

    }

    .no {
      background: #F7F7F8;
      color: #666;

    }

    .red {
      background: #901D22;
      color: #fff;

    }

  }
}

// 横屏模式下的样式
.landscape-mode {

  // @media screen and (min-width: 1000px) {
  #app {
    max-width: 100% !important;
  }

  .meeting-live1 {
    height: 100vh;
  }

  .meeting-live1 .all {
    flex-direction: row;
    flex: 1;
    overflow: hidden;

    &>div:first-child {
      width: 65%;
      flex: 0 0 65%;
      min-width: 0;
      overflow: hidden;
    }
  }

  .meeting-live1 .container {
    flex: 1 1 35%;
    width: 35%;
    min-width: 0;
    max-width: 35%;
    height: 100%;
    padding-bottom: 20px;
    overflow: hidden;
  }

  .meeting-live1 .container .van-tabs {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }

  .meeting-live1 .container .van-tabs__wrap,
  .meeting-live1 .container .van-sticky--fixed {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    width: 100% !important;
    transform: none !important;
  }

  .meeting-live1 .container .van-tabs__content {
    overflow: hidden;
  }

  .meeting-live1 .container .van-tab__pane-wrapper {
    overflow-y: auto;
    height: 100%;
  }

  .meeting-live1 .extend {
    width: 520px !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin: auto !important;

    img {
      width: 140px;
      top: 60% !important;
    }
  }

}



.phone_popup {
  padding: 40px 0px 0;

  h4 {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .submit {
    width: 80px;
    line-height: 30px;
    color: #fff;
    background: #901D22;
    border: 1px solid #901D22;
    border-radius: 10px;
    text-align: center;
    margin: 20px auto;
  }
}

.pwd_popup {
  padding: 40px 0px 0;

  h4 {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .submit {
    width: 80px;
    line-height: 30px;
    color: red;
    text-align: center;
    margin: 10px auto;
    font-size: 18px;
  }
}

.summary-popup {
  padding: 20px;
  // min-height: 400px;
  display: flex;
  flex-direction: column;

  .title {
    margin: 0 auto 20px;
    color: #000;
    font-size: 15px;
    text-align: center;
    font-weight: 400;
  }

  .info {
    width: 100%;
    padding: 15px;
    background: #F6F7F9;
    border-radius: 10px;
    margin-bottom: 15px;

    .name {
      font-size: 14px;
      font-weight: 600;
    }

    .speaker {
      color: #025292;
    }

  }

  .content {
    flex: 1;
    font-size: 13px;
    margin-bottom: 25px;
  }

  .label {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
  }

  .keywords {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 25px;

    p {
      padding: 2px 14px;
      background: #F6F7F9;
      color: #025292;
      border-radius: 15px;
    }
  }

  .tip {
    width: 80%;
    margin: 0 auto;
    max-width: 300px;

    img {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.meeting-live1 {
  .van-tabs--line {
    height: 100%;
    display: flex;
    flex-direction: column;

    .van-tabs__wrap {
      flex-shrink: 0;
      height: auto !important;
    }

    .van-tabs__nav {
      flex-wrap: nowrap;
    }

    .van-tabs__wrap--scrollable .van-tab {
      flex: 1 1 0 !important;
      // max-width: 80px;
    }

    .van-tab {
      flex: 1 1 0 !important;
      // max-width: 80px;
      min-width: 0;
      height: auto !important;
      min-height: 44px;
      padding: 6px 4px;
      line-height: 18px;
      white-space: normal;

      .van-tab__text,
      .van-tab__text--ellipsis {
        white-space: normal !important;
        word-break: break-all;
        overflow: visible !important;
        display: block !important;
        -webkit-line-clamp: unset !important;
        line-clamp: unset !important;
        -webkit-box-orient: unset !important;
        text-align: center;
        line-height: 18px;
      }
    }
  }

  .van-tabs__content {
    flex: 1;
    min-height: 0;
    height: auto !important;
  }

  .van-tab__pane-wrapper {
    overflow-y: auto;
  }
}

.charge {
  .van-field {
    padding: 0;
    align-items: center;
    margin-bottom: 15px;
    padding: 6px 10px 6px 20px;
    background: #FAFAFA;
    border: 0.5px solid #DADADA;
    border-radius: 5px;
  }


}

.want_look_tip {
  position: fixed;
  bottom: 30%;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto !important;
  width: 300px;
  background: rgba($color: #000000, $alpha: 0.7);
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 13px;
  z-index: 99;
}




.pic-lang {
  position: fixed;
  bottom: 0px;
  right: 10px;
  z-index: 9999;

  img {
    width: 80px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/LiveDetail.vue